import React, { useEffect, useRef } from 'react'

import CheckboxInput from '~/components/checkbox-input'
import { scrollToElement } from '~/utils/scrolling'

import { ConsentCheckboxWrapper } from './styles'

import type { PropsWithChildren } from 'react'

type ConsentCheckboxProps = {
  onChange: () => void
  className?: string
  alert?: boolean
  checked?: boolean
}

const ConsentCheckbox = ({
  className,
  alert,
  checked,
  onChange,
  children,
}: PropsWithChildren<ConsentCheckboxProps>) => {
  const scrollToRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (alert && scrollToRef.current) {
      scrollToElement(scrollToRef.current)
    }
  }, [alert, scrollToRef])

  return (
    <ConsentCheckboxWrapper
      role={alert ? 'alert' : null}
      $alert={alert}
      className={className}
      ref={scrollToRef}
    >
      <CheckboxInput checked={checked} label={children} onChange={onChange} />
    </ConsentCheckboxWrapper>
  )
}

export default ConsentCheckbox
